import { Divider } from "antd";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  analytics_cards,
  analytics_cards_all,
  analytics_cards_export,
} from "../../actions/cards/cards";
import { amountFormat } from "../../utils";
import ReportTable from "./ReportTable";
import { pdf } from "@react-pdf/renderer";
import MISExpenseReports from "../Common/PDF/MISPDF/MISExpenseReports";
import { saveAs } from "file-saver";
import BaseCurrency from "../Common/BaseCurrency";

const ReportsSec = (props) => {
  const dispatch = useDispatch();
  const cards = useSelector((state) => state.analytics.analytics_cards);
  const pdfData = useSelector((state) => state?.analytics?.analytics_cards_all);

  useEffect(() => {
    dispatch(analytics_cards({ type: "reports" }));
    dispatch(analytics_cards_all({ type: "reports", csv: true }));
    dispatch(analytics_cards_export({ pdf: true, csv: true, type: "reports" }));
    props.setFilterObj({});
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props.pdfURL(downloadPdf);
  }, [pdfData]);

  const downloadPdf = async () => {
    const blob = await pdf(
      <MISExpenseReports data={pdfData?.data?.response?.report || []} />
    ).toBlob();
    saveAs(blob, "MISExpenseReports.pdf");
  };

  const getObjs = () => {
    if (cards?.data?.response?.report?.length > 0) {
      return cards?.data?.response?.report?.[0]?.custom_fields?.map((ele) => ({
        title: ele.key?.replace("_", " "),
        dataIndex: "custom_fields",
        key: "custom_fields",
        render: (text, data) => (
          <div>
            {data?.custom_fields?.find((itm) => itm.key === ele.key)?.value}
          </div>
        ),
      }));
    }

    return [];
  };

  const getObjKeys = () => {
    if (cards?.data?.response?.report?.length > 0) {
      return cards?.data?.response?.report?.[0]?.custom_fields?.map(
        (ele) => ele.key
      );
    }

    return [];
  };

  const handlePaginationCall = (vals) => {
    vals.type = "reports";
    
    const finalVals = {};
    for (const key in vals) {
      if (Array.isArray(vals[key])) {
        finalVals[key] = vals[key].join(',');
      } else {
        finalVals[key] = vals[key];
      }
    }
    
    dispatch(analytics_cards(finalVals));
    dispatch(analytics_cards_export({ pdf: true, csv: true, ...finalVals }));
  }

  console.log(getObjKeys());
  const columns = useMemo(
    () => [
      {
        title: "Report ID",
        dataIndex: "report_id",
        key: "report_id",
        render: (text, data) => {
          return (
            <div className={`render_common_style status_${data?.Status}`}>
              {text}
            </div>
          );
        },
      },
      {
        title: "Employee Name",
        dataIndex: "employee_name",
        key: "employee_name",
      },
      {
        title: "Report Name",
        dataIndex: "report_name",
        key: "report_name",
      },
      {
        title: "From Date",
        dataIndex: "start_date",
        key: "start_date",
      },
      {
        title: "To Date",
        dataIndex: "end_date",
        key: "end_date",
      },
      {
        title: "Submitted On",
        dataIndex: "submitted_on",
        key: "submitted_on",
      },
      {
        title: "Amount",
        dataIndex: "total_amount",
        key: "total_amount",
        render: (text) => (
          <div>
            <BaseCurrency /> {amountFormat(text)}
          </div>
        ),
      },
      ...getObjs(),
      {
        title: "Cost center",
        dataIndex: "cost_center",
        key: "cost_center",
      },
      {
        title: "Project",
        dataIndex: "project",
        key: "project",
      },
      {
        title: "Approval Date",
        dataIndex: "approval_date",
        key: "approval_date",
        render: (text) => (text ? text : "-"),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text) => <div className={`status status_${text}`}>{text}</div>,
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ],
    [cards]
  );

  return (
    <>
      {/* <PDFDownloadLink document={} custom_fields={getObjKeys()} fileName="Reports.pdf">
        {({ blob, url, loading, error }) =>
          loading ? '' : props.setpdfURL(url)
        }
      </PDFDownloadLink> */}
      <div className="reports">
        <Divider />
      </div>
      <ReportTable
        columns={columns}
        scroll={{ x: 1800 }}
        data={cards?.data?.response?.report || []}
        total_records={cards?.data?.total_records}
        paginationCall={handlePaginationCall}
        payload={{ ...props.filterObj, ...props.apiFilters }}
      />
    </>
  );
};

export default ReportsSec;
